// @ts-expect-error not typed
import { IS_FOCUS_MODE_ON } from 'ContentEditorUI/lib/userAndLocalCacheSettings/constants';
// @ts-expect-error not typed
import { setSuperstoreUserSetting } from 'ContentEditorUI/redux/actions/settingsActions';
export const toggleFocusMode = isOpen => dispatch => {
  dispatch(setSuperstoreUserSetting(IS_FOCUS_MODE_ON, isOpen));
};